import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2Banks = loadable(() => import('./PSD2Banks'), {
  fallback: <Loader />,
});
